import { useState } from 'react';
import { ApolloError, useQuery } from '@apollo/client';
import { datadogRum } from '@datadog/browser-rum';
import { Server } from '@src/components/GqlProvider/GqlProvider';
import { Program, ProgramsResponse, PROGRAMS } from '@src/graphql/profile_edit/queries/programs';

export const getActiveAndVisiblePrograms = (programs: Program[]): Program[] => {
  return programs.filter((program) => {
    return program.active && program.visible;
  });
};

const useUserPrograms = (programIds?: string[]) => {
  const [programs, setPrograms] = useState<Program[]>([]);

  const onCompleted = (data: ProgramsResponse) => {
    if (data?.memberPrograms) {
      setPrograms(getActiveAndVisiblePrograms(data?.memberPrograms));
    }
  };

  const onError = (error: ApolloError): void => {
    datadogRum.addError(error, {
      message: `There was an error getting programs: ${error.message}`,
    });
  };

  const { loading, error } = useQuery<ProgramsResponse>(PROGRAMS, {
    context: {
      server: Server.CATALOG,
    },
    skip: !programIds?.length,
    onCompleted,
    onError,
  });

  return {
    loading,
    error,
    programs,
  };
};

export default useUserPrograms;
